// Generado por scripts/build-mobile-ui-catalog.mjs.
export const mobileUiCatalog = [
  ", mostralo únicamente si querés registrar tu visita a un stand o simposio.",
  ", respondo usando exclusivamente los datos de este evento.",
  "¿Cómo participás?",
  "¿Dónde se registra?",
  "¿Qué necesitás saber?",
  "· respuesta correcta",
  "✓ Respuesta registrada. Esperando resultados…",
  "1 intereses seleccionados",
  "1 seleccionados",
  "10 intereses seleccionados",
  "10 seleccionados",
  "11 intereses seleccionados",
  "11 seleccionados",
  "12 intereses seleccionados",
  "12 seleccionados",
  "13 intereses seleccionados",
  "13 seleccionados",
  "14 intereses seleccionados",
  "14 seleccionados",
  "15 intereses seleccionados",
  "15 seleccionados",
  "16 intereses seleccionados",
  "16 seleccionados",
  "17 intereses seleccionados",
  "17 seleccionados",
  "18 intereses seleccionados",
  "18 seleccionados",
  "19 intereses seleccionados",
  "19 seleccionados",
  "2 intereses seleccionados",
  "2 seleccionados",
  "20 intereses seleccionados",
  "20 seleccionados",
  "21 intereses seleccionados",
  "21 seleccionados",
  "22 intereses seleccionados",
  "22 seleccionados",
  "23 intereses seleccionados",
  "23 seleccionados",
  "24 intereses seleccionados",
  "24 seleccionados",
  "25 intereses seleccionados",
  "25 seleccionados",
  "26 intereses seleccionados",
  "26 seleccionados",
  "27 intereses seleccionados",
  "27 seleccionados",
  "28 intereses seleccionados",
  "28 seleccionados",
  "29 intereses seleccionados",
  "29 seleccionados",
  "3 intereses seleccionados",
  "3 seleccionados",
  "30 intereses seleccionados",
  "30 seleccionados",
  "31 intereses seleccionados",
  "31 seleccionados",
  "32 intereses seleccionados",
  "32 seleccionados",
  "33 intereses seleccionados",
  "33 seleccionados",
  "34 intereses seleccionados",
  "34 seleccionados",
  "35 intereses seleccionados",
  "35 seleccionados",
  "36 intereses seleccionados",
  "36 seleccionados",
  "37 intereses seleccionados",
  "37 seleccionados",
  "38 intereses seleccionados",
  "38 seleccionados",
  "39 intereses seleccionados",
  "39 seleccionados",
  "4 intereses seleccionados",
  "4 seleccionados",
  "40 intereses seleccionados",
  "40 seleccionados",
  "41 intereses seleccionados",
  "41 seleccionados",
  "42 intereses seleccionados",
  "42 seleccionados",
  "43 intereses seleccionados",
  "43 seleccionados",
  "44 intereses seleccionados",
  "44 seleccionados",
  "45 intereses seleccionados",
  "45 seleccionados",
  "46 intereses seleccionados",
  "46 seleccionados",
  "47 intereses seleccionados",
  "47 seleccionados",
  "48 intereses seleccionados",
  "48 seleccionados",
  "49 intereses seleccionados",
  "49 seleccionados",
  "5 intereses seleccionados",
  "5 seleccionados",
  "50 intereses seleccionados",
  "50 seleccionados",
  "6 intereses seleccionados",
  "6 seleccionados",
  "7 intereses seleccionados",
  "7 seleccionados",
  "8 intereses seleccionados",
  "8 seleccionados",
  "9 intereses seleccionados",
  "9 seleccionados",
  "Abrí el canal y dejá el audio preparado antes de que comience la prueba.",
  "Abrí el reproductor de",
  "Abrir archivo del trabajo",
  "ABRIR EN LA APP",
  "Abrir presentación PowerPoint",
  "Abrir reproductor",
  "Abstract",
  "ABSTRACT",
  "ACCESO VALIDADO",
  "Activar",
  "Actualizado",
  "Actualizando",
  "Afecta sesiones en curso, quizzes y presentaciones.",
  "AFINÁ EL PROGRAMA",
  "Agregá las sesiones que quieras tener siempre a mano.",
  "Agregar",
  "Agregar a mi agenda",
  "AI CONCIERGE PERSONAL",
  "Ajustes",
  "Alemania",
  "Arabia Saudita",
  "Argentina",
  "Asistente",
  "Audio original y síntesis de la sesión disponibles.",
  "Auspicia esta sesión",
  "Australia",
  "Austria",
  "AUTOR",
  "AUTORES",
  "Bangladés",
  "Beacons configurados. Buscando señal cercana…",
  "Bélgica",
  "Bolivia",
  "Borrar búsqueda",
  "Brasil",
  "Buscando beacons y emisores del evento…",
  "Buscando eventos activos…",
  "Buscar empresa o número de stand",
  "Buscar en el programa",
  "Buscar país",
  "Buscar sesión, tema o faculty",
  "Buscar título, código, autor, tema o subevento",
  "Buscar trabajos científicos",
  "Canadá",
  "Cancelar",
  "Cargando la nueva pantalla",
  "Cargando opciones del evento…",
  "Cargando…",
  "Cerrar",
  "Cerrar acceso",
  "Cerrar concierge",
  "Cerrar configuración",
  "Cerrar detalle",
  "Cerrar filtros",
  "Cerrar países",
  "Cerrar perfil",
  "Cerrar preferencias",
  "Cerrar quiz",
  "Cerrar sesión",
  "Cerrar trabajo",
  "Cerrar traducción",
  "Chile",
  "China",
  "COAUTORES",
  "Código de validación",
  "Colombia",
  "Comenzar a emitir",
  "Completá tus datos y elegí dónde recibir el código de validación.",
  "Conectando con la sesión…",
  "Configurá la sincronización y, si lo necesitás, simulá el momento en el que se encuentra el evento.",
  "Configurar servidor",
  "Confirmar código",
  "Consultando el programa del evento…",
  "CONTINUE",
  "Contraseña",
  "Control de presencia al acceso",
  "Corea del Sur",
  "Costa Rica",
  "Cuando el organizador publique las salas de exposición y ubique los stands, aparecerán aquí automáticamente.",
  "Cuba",
  "Currículum",
  "Datos locales",
  "Detalle del trabajo",
  "Detecta por Bluetooth los teléfonos emisores de stands y sesiones mientras la app está abierta.",
  "Detener emisión",
  "Día",
  "Dinamarca",
  "Dirección de la API",
  "Disertante, coordinador o presidente",
  "Disponible localmente",
  "Ecuador",
  "Egipto",
  "El audio final y el resumen estarán disponibles en breve.",
  "El código es temporal, no contiene tu nombre visible y sólo funciona para este evento.",
  "El evento no tiene beacons físicos activos ni teléfonos emitiendo. Revisá la configuración en Organize.",
  "El Salvador",
  "Elegí el stand o la sesión. La emisión funciona mientras meetingPlanner permanece abierta.",
  "Elegí lo que más te interesa. Podrás modificarlo cuando quieras.",
  "Elegí primero el tipo de acceso. Sólo tendrás que identificarte una vez en este dispositivo.",
  "Elegí tu idioma y escuchá la sesión en tiempo real.",
  "Elegir otro tipo de acceso",
  "email",
  "Email",
  "Emiratos Árabes Unidos",
  "Emisión detenida",
  "Emisión no habilitada",
  "Emitiendo ahora",
  "En mi agenda",
  "Encontrá cada empresa y su ubicación dentro del evento.",
  "Enviamos un código de 4 dígitos a",
  "Enviar código por email",
  "Enviar código por WhatsApp",
  "Enviar pregunta",
  "Escanear otra persona",
  "Escuchar grabación",
  "Escuchar grabación y ver resumen",
  "Escuchar respuesta",
  "Escuchar traducción en vivo",
  "España",
  "Estados Unidos",
  "Este dispositivo quedó registrado. No volveremos a pedirte acceso salvo que cierres la sesión.",
  "Este teléfono como emisor",
  "Este trabajo todavía no tiene contenido disponible para visualizar.",
  "Evento activo",
  "EXPOSICIÓN COMERCIAL",
  "Expositor",
  "Faculty",
  "Filtrar expositores",
  "Filtros",
  "Finlandia",
  "Formación académica",
  "Francia",
  "Generar un código nuevo",
  "GEOLOCALIZACIÓN",
  "Grabando ·",
  "Grecia",
  "Guardar cambios",
  "Guardar y continuar",
  "Guardar y sincronizar",
  "Guatemala",
  "Hay 10 quizzes activos",
  "Hay 11 quizzes activos",
  "Hay 12 quizzes activos",
  "Hay 13 quizzes activos",
  "Hay 14 quizzes activos",
  "Hay 15 quizzes activos",
  "Hay 16 quizzes activos",
  "Hay 17 quizzes activos",
  "Hay 18 quizzes activos",
  "Hay 19 quizzes activos",
  "Hay 2 quizzes activos",
  "Hay 20 quizzes activos",
  "Hay 21 quizzes activos",
  "Hay 22 quizzes activos",
  "Hay 23 quizzes activos",
  "Hay 24 quizzes activos",
  "Hay 25 quizzes activos",
  "Hay 26 quizzes activos",
  "Hay 27 quizzes activos",
  "Hay 28 quizzes activos",
  "Hay 29 quizzes activos",
  "Hay 3 quizzes activos",
  "Hay 30 quizzes activos",
  "Hay 31 quizzes activos",
  "Hay 32 quizzes activos",
  "Hay 33 quizzes activos",
  "Hay 34 quizzes activos",
  "Hay 35 quizzes activos",
  "Hay 36 quizzes activos",
  "Hay 37 quizzes activos",
  "Hay 38 quizzes activos",
  "Hay 39 quizzes activos",
  "Hay 4 quizzes activos",
  "Hay 40 quizzes activos",
  "Hay 41 quizzes activos",
  "Hay 42 quizzes activos",
  "Hay 43 quizzes activos",
  "Hay 44 quizzes activos",
  "Hay 45 quizzes activos",
  "Hay 46 quizzes activos",
  "Hay 47 quizzes activos",
  "Hay 48 quizzes activos",
  "Hay 49 quizzes activos",
  "Hay 5 quizzes activos",
  "Hay 50 quizzes activos",
  "Hay 6 quizzes activos",
  "Hay 7 quizzes activos",
  "Hay 8 quizzes activos",
  "Hay 9 quizzes activos",
  "Hay un quiz activo",
  "Hay un quizz activo",
  "Hola",
  "Honduras",
  "Hora",
  "hostess",
  "Hungría",
  "IDENTIFICACIÓN DEL EVENTO",
  "IDIOMA DE LA APP",
  "India",
  "Indonesia",
  "Información institucional pendiente",
  "Ingresá el código",
  "Ingresar",
  "Interacción de la sesión",
  "Irán",
  "Irlanda",
  "Israel",
  "Italia",
  "Japón",
  "La app necesita conectarse una vez para guardar el programa en este teléfono.",
  "La app nunca se conecta directamente a SQL Server ni almacena sus credenciales.",
  "La empresa debe habilitar esta función desde Organize.",
  "La selección queda guardada en este teléfono.",
  "La sesión todavía no está disponible en el programa local. Actualizá el programa e intentá nuevamente.",
  "Limpiar",
  "Limpiar búsqueda",
  "Limpiar filtros",
  "Los trabajos aceptados aparecerán aquí cuando sean publicados desde Organize.",
  "Main sponsor",
  "Main sponsor del evento",
  "MEETING ORGANIZE",
  "meetingPlanner",
  "MEETINGPLANNER MOBILE",
  "México",
  "Mi agenda",
  "Mi QR",
  "MOBILE",
  "Modificar mis intereses",
  "Mostrar resultados",
  "Necesitamos acceso a la cámara",
  "Nicaragua",
  "No encontramos sesiones",
  "No hay eventos activos publicados.",
  "No hay expositores que coincidan con la búsqueda.",
  "No hay opciones disponibles en este evento.",
  "No hay otras participaciones publicadas.",
  "No pudimos cargar el programa",
  "No se pudo abrir el archivo",
  "No se pudo abrir el PDF",
  "No se pudo abrir la consulta por IA",
  "No se pudo abrir la presentación",
  "No se pudo abrir la traducción",
  "No se pudo cambiar el estado del quiz",
  "No se pudo registrar la respuesta",
  "No se pudo traducir la app",
  "No tenés stands o sesiones habilitados para emitir.",
  "No tiene sesiones auspiciadas publicadas.",
  "Nombre y apellido",
  "nombre@email.com",
  "Noruega",
  "Nueva Zelanda",
  "País",
  "Países Bajos",
  "Panamá",
  "Para continuar, registrate y validá tu email o WhatsApp.",
  "Paraguay",
  "Participa en",
  "Participación",
  "Participante del congreso",
  "PASE VOLUNTARIO DE VISITA",
  "PDF",
  "Pedile al asistente que abra “Mi QR” en su app. El registro sólo se realiza cuando lo brinda voluntariamente.",
  "PERFIL DE INTERESES",
  "Perfil profesional",
  "Permitir cámara",
  "Personal asociado a un stand",
  "PERSONAL DE EXPOSITOR",
  "Personalizá tu consulta por IA",
  "Perú",
  "PLANO DE EXPOSITORES",
  "PLANO SELECCIONADO",
  "Plano todavía no publicado",
  "Podés preguntar por tu agenda, horarios, salas, especialistas, trabajos científicos y stands.",
  "PODÉS SEGUIR PREGUNTANDO",
  "Polonia",
  "por",
  "Portugal",
  "Preguntale a Meeting Organize",
  "Preparando tu programa…",
  "Presentación",
  "PRESENTACIÓN",
  "Probá buscar por otra parte del título, código, autor, tema o subevento.",
  "PROBÁ CON",
  "Probá con otra búsqueda o limpiá los filtros.",
  "Programa",
  "PROGRAMA CIENTÍFICO",
  "Puerto Rico",
  "Quiz activo",
  "Quizzes activos",
  "Quizzes de la sesión",
  "Registrar geolocalización",
  "Registrar una visita",
  "Registro obligatorio",
  "Reino Unido",
  "Reintentar",
  "República Dominicana",
  "Requiere registro previo",
  "Responsable de presencia en una sesión",
  "respuestas",
  "Rumania",
  "Rusia",
  "s · tocá detener para consultar",
  "SALAS DE EXPOSITORES",
  "Salir del evento",
  "Salón",
  "Salón por confirmar",
  "Se está usando la fecha y hora reales del teléfono.",
  "Se renueva automáticamente ·",
  "Se usa únicamente para leer el QR que el asistente decide mostrar.",
  "Seleccioná al menos una opción",
  "Seleccioná la sesión que querés abrir.",
  "Seleccioná tu evento",
  "Seleccioná tu país",
  "Seleccionar idioma",
  "Seleccionar país",
  "Servidor",
  "Sesión guardada en mi agenda",
  "SESIONES QUE AUSPICIA",
  "Simposio auspiciado",
  "Simular fecha y hora",
  "Sin coincidencias",
  "Sin conexión",
  "Sin sincronizar",
  "SINCRONIZACIÓN",
  "Sincronizando el programa por primera vez…",
  "Solicitá un código al email o WhatsApp registrado en Organize.",
  "Staff",
  "Stand",
  "Stands",
  "Stands y expositores",
  "Subevento",
  "Subeventos",
  "Suecia",
  "Suiza",
  "superposición horaria",
  "superposiciones horarias",
  "Tailandia",
  "Taiwán",
  "Temas",
  "Temas Libres",
  "Temática",
  "Tipos de sesión",
  "Tocá para abrir la sesión y responder.",
  "Tocá para seleccionar una sesión.",
  "Tocá un stand para destacarlo o quitarlo del filtro.",
  "Todas las temáticas",
  "Todavía no hay trabajos publicados",
  "Todo el faculty",
  "Todos",
  "Todos los expositores",
  "Todos los salones",
  "Todos los subeventos",
  "trabajo",
  "TRABAJO CIENTÍFICO",
  "trabajos",
  "Trabajos aceptados, abstracts y presentaciones del evento.",
  "Trabajos científicos",
  "Traducción en procesamiento",
  "Traducción simultánea",
  "TRADUCCIÓN SIMULTÁNEA",
  "Tu agenda está vacía",
  "Tu agenda tiene",
  "Tu contraseña",
  "Tu nombre completo",
  "Turquía",
  "Ubicación pendiente",
  "UBICACIONES EN",
  "Ucrania",
  "Uruguay",
  "Validá tu acceso para participar del quiz",
  "Validar acceso",
  "Venezuela",
  "Ver",
  "Ver PDF",
  "Ver presentación",
  "Ver programa completo",
  "Ver resultados",
  "Verificá la conexión con el servidor y volvé a intentarlo.",
  "Verificá la conexión con el servidor.",
  "Verificá la conexión y la dirección del servidor.",
  "Vietnam",
  "Visita registrada",
  "Visita ya registrada",
  "Volver y corregir los datos",
  "votos",
  "WhatsApp",
  "WhatsApp (opcional)"
] as const;
